import { get } from 'svelte/store';
import { devices } from 'src/stores/lists/devices';
import { getTemplateComponents, isXT1Module } from '../../../helpers/xt1_helpers/template_helpers';
import type { Device } from '../../../types/Device';

export const filterXT1Temperatures = (device: Device, filtered: any[]) => {
	if (isXT1Module(device.type) && /^(sensor|thermostat)$/.test(device.category)) {
		const sensorID = getTemplateComponents(device, null, /^(current_temperature)$/)?.[0]?.config?.id;
		if (sensorID) {
			filtered.push({
				id: device.id,
				image: device.image,
				relay_id: device.id,
				room_id: device.room_id,
				name: device.name,
				ext_sen_id: sensorID,
				is_virtual_temp: true,
			});
		}
	}
	return filtered;
};

export const relaysXT1Control = (deviceID: Device['id']) => {
	const device = get(devices)?.[deviceID];
	const xt1RelayComponent =
		isXT1Module(device?.type) && getTemplateComponents(device, null, /state|position/)?.[0];
	if (xt1RelayComponent) {
		const channel = xt1RelayComponent.config.id + 1;
		const r = `dev:${deviceID}:${xt1RelayComponent.type}${channel}`;
		const off = {
			r,
			persist: true,
			asneeded: 1,
			set: xt1RelayComponent.type == 'number' ? 0 : false,
		};
		const on = {
			r,
			persist: true,
			asneeded: 1,
			set: xt1RelayComponent.type == 'number' ? 100 : true,
		};
		return { on, off };
	}
	return null;
};
